 <div class="withdraw-iban" [formGroup]="parent">
  <h2 class="ds-heading-2">{{ 'ACCOUNT.withdrawalV2.bank.heading' | translate }}</h2>
  <ng-container *ngFor="let iban of ibanList">
    <app-ds-radio-option
      [value]="iban.type === 'account' ? iban?.value : iban?.type"
      [selected]="iban.type === 'account' ? ibanControl.value : typeControl.value"
      (clicked)="onIbanChange(iban)"
      variant="box"
    >
      <ng-container ds-radio-title>{{ iban?.title | translate }}</ng-container>
      <ng-container ds-radio-desc>{{ iban?.desc | translate }}</ng-container>
    </app-ds-radio-option>
    <ng-container *ngIf="iban.type === 'new' && typeControl.value === 'new'">
      <div class="ds-form-row" [class.has-error]="newIbanControl.hasError('invalidIban')">
        <label class="ds-label">{{ 'ACCOUNT.withdrawalV2.bank.input.label' | translate }}</label>
        <input
          class="ds-input"
          type="text"
          [placeholder]="'ACCOUNT.withdrawalV2.bank.input.placeholder' | translate"
          [formControlName]="'newIban'"
          (keyup.enter)="onContinue()"
          (focus)="onFocus()"
        />
        <div *ngIf="newIbanControl.hasError('invalidIban')" class="ds-input-error">
          {{ 'ACCOUNT.withdrawalV2.bank.input.IBANError' | translate }}
        </div>
      </div>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="typeControl.value === 'new'">
    <app-ds-callout
      variant="info"
      [title]="'ACCOUNT.withdrawalV2.bank.info.title' | translate"
      [description]="'ACCOUNT.withdrawalV2.bank.info.description' | translate"
    ></app-ds-callout>
  </ng-container>
</div>

<div class="withdraw-buttons" [class.mobile-buttons]="isMobileApp"  [ngStyle]="{display: isMobileApp ? 'block' : 'flex'}">
  <app-ds-button [width]="isMobileApp ? 'full' : 'auto'"  [disabled]="parent.invalid" (clicked)="onContinue()">
    {{ 'ACCOUNT.withdrawalV2.buttons.next' | translate }}
  </app-ds-button>
  <app-ds-button [width]="isMobileApp ? 'full' : 'auto'"  variant="outline" (clicked)="onBack()">{{ 'ACCOUNT.withdrawalV2.buttons.previous' | translate }}</app-ds-button>
</div>
